import script from "./NewHomePage.vue?vue&type=script&setup=true&lang=js"
export * from "./NewHomePage.vue?vue&type=script&setup=true&lang=js"

import "./NewHomePage.vue?vue&type=style&index=0&id=491113f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-491113f4"]])

export default __exports__